import {all, call, put, takeLatest} from "redux-saga/effects";
import {
  getTimezoneList,
  setTimezoneList,
  setTimezoneListError
} from "../../reducers/timezoneReducer/timezoneReducer";
import {API} from "../../../API/API";
import {TimezoneApiTimezoneListRequest, TimezoneApiTimezoneListResponse} from "../../../proto/generated/api_entities_pb";
import {mapTimeZoneEntityToITimezone} from "../../reducers/fleetReducer/fleetMappers";

function* getTimezoneListSaga() {
  try {
    const req = new TimezoneApiTimezoneListRequest().setQuery('');
    const res: TimezoneApiTimezoneListResponse = yield call(API.getTimezoneList, req);
    
    const timezones = res.getTimezonesList().map(tz => mapTimeZoneEntityToITimezone(tz));
    
    yield put(setTimezoneList({timezones}));
  } catch (error: any) {
    yield put(setTimezoneListError({
      errorMessage: error?.message || 'Failed to load timezones'
    }));
  }
}

export function* timezoneSaga() {
  yield all([
    takeLatest(getTimezoneList.type, getTimezoneListSaga),
  ]);
}

